import type { StorageKey } from "@exonn/storage";
import { localStorageDriver } from "src/storage/localeStorage.driver.ts";
import { reaction } from "mobx";

export const persistStore = <
  Store extends Record<string, any> = Record<string, any>,
>(
  store: Store,
  key: StorageKey,
  properties: (keyof Store)[],
) => {
  type PersistedState = Partial<Record<keyof Store, any>>;
  const persistedState = localStorageDriver.get<PersistedState>(key);
  if (persistedState) {
    properties.forEach((key) => {
      if (persistedState[key]) {
        store[key] = persistedState[key];
      }
    });
  }

  const startPersisting = () => {
    return reaction(
      () => {
        return properties.reduce((acc, property) => {
          return {
            ...acc,
            [property]: store[property],
          };
        }, {} as PersistedState);
      },
      (values) => {
        localStorageDriver.set<PersistedState>(key, values);
      },
    );
  };

  return {
    startPersisting,
  };
};
